import * as styledElements from "./ReleasePageStyles";
import ReleaseCard from "../ReleaseCard";
import { PostView } from "../../../utils/posts";

const ReleasePage = ({
  title,
  posts,
}: {
  title: string;
  posts: PostView[];
}) => {
  return (
    <styledElements.Page>
      <styledElements.Title>{title}</styledElements.Title>
      <styledElements.Container>
        {posts.map((post) => (
          <ReleaseCard key={post.id} post={post} />
        ))}
      </styledElements.Container>
    </styledElements.Page>
  );
};

export default ReleasePage;
